(function() {
    let defaults = {
        lang: 'en'
    };
    let options = Object.assign({}, defaults, window.__tg_widget_options || {});
    let path = document.currentScript.src.substring(0, document.currentScript.src.lastIndexOf('/'));
    let langs = {
        en: {
            inv: 'Hi! Please send your question here!',
            send: 'Send',
            agents: {
                'lidia': {
                    name: 'Lidia',
                    pic: 'ava-lidia.jpg',
                    title: 'Your Manager',
                    link: 'https://telegram.me/BHIntl_1',
                    link_imo: 'https://s.imoim.net/qo5xvj'
                },
                'marina': {
                    name: 'Marina',
                    pic: 'ava-marina.jpg',
                    title: 'Your Affiliate Manager',
                    link: 'https://telegram.me/affiliate2daycom'
                }
            }
        },
        ru: {
            inv: 'Привет! Напишите ваш вопрос здесь!',
            send: 'Отправить',
            agents: {
                'lidia': {
                    name: 'Лидия',
                    pic: 'ava-lidia.jpg',
                    title: 'Ваш менеджер',
                    link: 'https://telegram.me/BHIntl_1',
                    link_imo: 'https://s.imoim.net/qo5xvj'
                },
                'marina': {
                    name: 'Марина',
                    pic: 'ava-marina.jpg',
                    title: 'Ваш партнёрский менеджер',
                    link: 'https://telegram.me/affiliate2daycom'
                }
            }
        },
    };
    const agent = document.location.hostname.includes('affiliate2day') ? 'marina' : 'lidia';
    const lang = langs[options.lang] || langs.en;
    let container = document.querySelector('#_tg_widget');
    let trigger_size = 64;
    if(container && container.dataset.triggerSize) {
        trigger_size = container.dataset.triggerSize;
    }
    if(!container) {
        container = document.createElement('div');
        container.id = "_tg_widget";
        container.style.position = 'fixed';
        container.style.zIndex = '9';
        document.body.appendChild(container);
    }
    const sh = container.attachShadow({ mode: "closed" });
    const body = document.createElement('div');
    body.className = "tg-widget-wrap";
    const the_agent = lang.agents[agent];
    body.innerHTML = `
<link href="https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap" rel="stylesheet">
<style>

:host {    
    font-family: "Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    font-size: 14px;
    line-height: 1.4;
    color: #000;    
    position: absolute;    
    right: 20px;
    bottom: 20px;   
}
@media (max-width: 640px) {
    :host, :root {
        font-size: 12px;
    }
}
.tg-widget-triggers {
    display: none; 
}
.tg-widget-trigger {
    padding: 0;
}
.tg-widget { 
    display: flex;
    flex-direction: column;
    width: min(100vw, 450px);
    box-shadow: 0 0 15px rgba(0,0,0,0.1);
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 9;
}
.tg-widget--hidden {
    display: none;
}
.tg-widget--hidden + .tg-widget-triggers {
    display: flex;
    gap: 10px;
}
.tg-widget__header {
    background: #fff;
    padding: 2em;
}
button {    
    border: none;
    background: none;
    cursor: pointer;
}
.tg-widget__close {
    background: url(https://static.behappy2day.com/js/telegram-widget/img/close.svg);
    background-size: cover;
    position: absolute;
    right: 30px;
    top: 30px;
    width: 15px;
    height: 15px;
}
.tg-widget__agent {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
}
.tg-widget__agent-avatar {
    flex: 0 0 54px;
    position: relative;
    height: 54px;
}
.tg-widget__agent-avatar-img, .chat__message-avatar-img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    object-position: center top;
    position: absolute;
    left: 0;
    top: 0;
}
.tg-widget__agent-caption {
    font-size: 1.2em;
    line-height: 1.2;
}
.tg-widget__agent-name {
    font-weight: 700;
}
.tg-widget__body {
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
    min-height: 27em;
    background: #eceef6;
    padding: 1.7rem;
}
.chat {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;    
    display: flex;
    flex-direction: column;
}
.chat__message {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 7px;    
    margin-top: auto;
}
.chat__message-avatar {
    flex: 0 0 36px;
    height: 36px;
    position: relative;
}
.chat__message-text {
    flex: 1;
    min-height: 6em;
    background: #f9fafc;
    border-radius: 15px 15px 15px 0;
    padding: 20px 15px;
    display: flex;
    flex-direction: column;
}
.chat__message-username {
    color: #a6a6a6;    
    font-weight: 700;
    flex: 0 0 auto;
    font-size: 1.2em;
}
.chat__message-text-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}
.tg-widget__btn {
    display: none;
}
.send {
    background: #2ca1dd;
    border-radius: 15px;
    font-size: 1.4em;
    line-height: 3;
    color: #FFF;
}
.tg-widget__btn--imo .send {
    background-color: rgb(0, 157, 255);
}
.send .icon {
    height: 1.25em;
    vertical-align: middle;
    width: 1.25em;
}
</style>
<div class="tg-widget tg-widget--hidden">
    <div class="tg-widget__header">
        <button class="tg-widget__close" type="button"></button>
        <div class="tg-widget__agent">
            <div class="tg-widget__agent-avatar">
                <img class="tg-widget__agent-avatar-img" src="${path}/img/${the_agent.pic}" width="128" height="128" alt="">    
            </div>     
            <div class="tg-widget__agent-caption">
                <div class="tg-widget__agent-name">${the_agent.name}</div>
                <div class="tg-widget__agent-title">${the_agent.title}</div>        
            </div>
        </div>
    </div>
    <div class="tg-widget__body">
        <div class="chat"><div class="chat__message">
                <div class="chat__message-avatar">
                    <img class="chat__message-avatar-img" src="${path}/img/${the_agent.pic}" width="128" height="128" alt="">
                </div>
                <div class="chat__message-text">
                    <div class="chat__message-username">${the_agent.name}</div>
                    <span class="chat__message-text-content">${lang.inv}</span>
                </div>
            </div></div>
        <a class="tg-widget__btn" href="${the_agent.link}" target="_blank" data-type="tg">
            <button type="button" class="send"><img src="${path}/img/send.svg" width="231" height="231" class="icon" alt="">  ${lang.send}</button>
        </a>        
    </div>
</div>
<div class="tg-widget-triggers">
    <button type="button" class="tg-widget-trigger" data-type="tg"><img src="${path}/img/collapsed.svg" width="${trigger_size}" height="${trigger_size}" alt=""></button>
</div>
`;
    if(the_agent.link_imo) {
        body.querySelector('.tg-widget-triggers').insertAdjacentHTML('beforeend', `
<button type="button" class="tg-widget-trigger tg-widget-trigger--imo" data-type="imo"><img src="${path}/img/imo-collapsed.svg" width="${trigger_size}" height="${trigger_size}" alt=""></button>`);
        body.querySelector('.tg-widget__body').insertAdjacentHTML('beforeend', `
<a class="tg-widget__btn tg-widget__btn--imo" href="${the_agent.link_imo}" target="_blank" data-type="imo">
    <button type="button" class="send"><img src="${path}/img/imo.svg" width="231" height="231" class="icon" alt="">  ${lang.send}</button>
</a>`);
    }

    body.querySelectorAll('.tg-widget-trigger').forEach(function(el) {
        el.addEventListener('click', function () {
            body.querySelector('.tg-widget--hidden').classList.remove('tg-widget--hidden');
            body.querySelector(`.tg-widget__btn[data-type='${this.dataset.type}']`).style.display = 'contents';
        })
    });
    body.querySelector('.tg-widget__close').addEventListener('click', function () {
        body.querySelector('.tg-widget').classList.add('tg-widget--hidden');
        body.querySelectorAll(`.tg-widget__btn`)
            .forEach(function(el) {
                el.style.display = 'none';
            });
    });
    sh.appendChild(body);
})();